import React, { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import _isEmpty from "lodash/isEmpty"
import _get from "lodash/get"
import { useRouter } from "next/router"
import { useTranslation } from "next-i18next"

import usePdpi18n from "@/i18n/usePdpi18n"
import { getStock } from "@/utils/cart"
import { addToCompareProduct, removeFromCompareProduct } from "@/utils/product"
import {
  getLocationByCookies,
  getPDPUrl,
  getPdpUrlPath,
  getShortenedUrlPath,
  getShortenedUrlwithGeneral,
  getUserPersona,
  isCanadaSite,
  showNewBadge,
} from "@/utils/helper"
import CONSTANTS, { SWATCH_NA } from "@/constants/index"
import {
  getDefaultStateData,
  getFormatedImages,
  getPdpProps,
  showToaster,
} from "@/components/ProductDetail/v3/ProductDetailView/utils"
import {
  checkProductCategory,
  getShippingLocations,
  getZipCodeJsonFile,
  getColorDataObject,
  checkUserZipCode,
  getColorFinishData,
} from "@/components/ProductDetail/v3/productDetailsHelper"
import { shareaddToCart as addToCartHelper } from "@/components/sharedCart/shareCartHelper"

import {
  getGenericListPath,
  getstateList,
  selectGenericState,
  showPreviewCart,
} from "@/store/features/genericSlice"
import { selectAuthState } from "@/store/features/authSlice"
import { selectCartState } from "@/store/features/cartSlice"
import {
  getDiscontinuedProductValue,
  getProductBySlug,
  getProductBySlugAndSku,
  searchPdp,
  setPDP,
  setProductInfo,
  selectPdpState,
  setRequiredItemsSkuData,
  getPdpTooltip,
} from "@/store/features/pdpSlice"
import { compareState } from "@/store/features/compareSlice"
import { selectFavoritesState } from "@/store/features/favoritesSlice"

import ProductDetailView from "@/components/ProductDetail/v3/ProductDetailView"
import PDPLoader from "@/components/ProductDetail/v3/PDPLoader"
import { getPdpRedirectUrl, parseToBoolean } from "@/utils/index"

import MissingImage from "@/public/images/image-missing.png"

const ProductDetail = props => {
  const {
    data: authorData = {},
    pdpData: pdpDataServer = {},
    slug: slugProp = "",
    skuId = "",
    initialImgAlt = "",
    initialImgUrl = "",
    analyticsData = {},
  } = props || {}

  const dispatch = useDispatch()
  const router = useRouter()
  const { t } = useTranslation("common")

  const { stateListPath } = useSelector(selectGenericState)
  const { access_token: accessToken, user: { koc: isIscUser = "" } = {} } =
    useSelector(selectAuthState)
  const { cart, cart: { id: cartLoaded = "" } = {} } =
    useSelector(selectCartState)

  const [pdpData, setPdpData] = useState(pdpDataServer)
  const [slug, setSlug] = useState(slugProp)

  const { comparedProducts, category: productCategory } =
    useSelector(compareState)

  const blankState = getDefaultStateData(pdpData)
  const { favorites } = useSelector(selectFavoritesState)
  const { saveToListLineItems } = useSelector(selectFavoritesState)
  const { globalConfig } = useSelector(selectGenericState)

  const {
    general = {},
    internationalization: {
      locale = "",
      currencySign = "",
      currencyCode = "",
    } = {},
    apiEndpoints: { reverseGeo = "" } = {},
  } = globalConfig

  const [state, setState] = useState({ selectedSku: skuId })
  const [superSku, setSuperSku] = useState("")
  const [availableColorFirstSku, setAvailableColorFirstSku] = useState("")
  const [productServices, setProductServices] = useState("")
  const [pdprops, setPdprops] = useState({})
  const [comboSku, setComboSku] = useState([])
  const [regionSoldOnline, setRegionSoldOnline] = useState([])
  const [imagesData, setImagesData] = useState([])
  const [videoIds, setVideoIds] = useState([])
  const [pricesData, setPricesData] = useState([])
  const [listPrices, setListPrices] = useState([])
  const [discountedPrices, setDiscountedPrices] = useState([])
  const [discountPercent, setDiscountPercent] = useState([])
  const [isType, setIsType] = useState([])
  const [badgesProps, setBadgesProps] = useState([])
  const [excludedStates, setExcludedStates] = useState([])
  const [presetConfigObject, setPresetConfigObject] = useState({})
  const [partReplacementSuggestions, setPartReplacementSuggestions] = useState(
    []
  )
  const [replaceAddToCartCtaLink, setReplaceAddToCartCtaLink] = useState("")
  const [isPdpPropsLoaded, setIsPdpPropsLoaded] = useState(false)
  const [isLoadTargetRequired, setIsLoadTargetRequired] = useState(false)
  const [isPriceChecked, setIsPriceChecked] = useState(false)
  const [colorSKUDetailss, setColorSKUDetailss] = useState()
  const [isSkuOptionClicked, setIsSkuOptionClicked] = useState(false)
  const [isInventoryUpdates, setIsInventoryUpdates] = useState(false)

  const {
    RegionBrandName_s: pdpBrnadName = "",
    productName_s: productNameInit = "",
  } = pdpData

  const {
    disableCommerce: disableEcommerce = false,
    siteName: brandName = "",
    findProPagePath: findProPagePathUrl = "/",
    findStorePagePath = "",
    newBadgeName = "",
    saleBadgeName = "",
    exclusiveBadgeName = "",
    discontinuedBadgeName = "",
    lwAppName = "kohler",
    servicePartsLandingPath = "",
  } = general

  const badgeText = {
    new: newBadgeName,
    onSale: saleBadgeName,
    exclusive: exclusiveBadgeName,
    discontinued: discontinuedBadgeName,
  }

  const {
    persona = "",
    selectedSku = "",
    installationDataFromProp = [],
    designServiceDataFromProp = [],
    jsonFileUrl = "",
    imageClickCounter = 0,
    statesData = {},
    findInstallerPath = "",
    productDetailData = {},
    variantData = [],
    ctData = {},
    loadShowEvent = false,
    clickedProductVariant = false,
    availableStock = 0,
    dimensionData = {},
    variantOptions = [],
    isOptionClicked = false,
  } = state

  const {
    id,
    productName_s: productNames = "",
    RegionBrandName_s: regionBrandNames = "",
    ProductLocalCategory_s: productLocalCategory = "",
    Product_Category: productCate = "",
  } = productDetailData

  const category = productLocalCategory || productCate
  const localCategory = productDetailData.category1_s

  const servicePartPath = getShortenedUrlPath(servicePartsLandingPath)
  const isParts =
    location && servicePartPath
      ? location?.href?.toLowerCase().includes(servicePartPath)
      : false

  const {
    pdp: {
      data: {
        primaryBundleSKU_s: primaryBundleSKUs = "",
        bundleSKUList_ss: bundleSKUList = [],
      } = {},
    } = {},
    requiredItemsSkuData = {},
  } = useSelector(selectPdpState)

  const threeSixtyResourceDataState = {}
  if (requiredItemsSkuData?.data) {
    const { data = {} } = requiredItemsSkuData
    if (data[0]?.["ItemResource.IMGSpinSet.resourceFullWebURL_ss"]) {
      threeSixtyResourceDataState.resourceAltText =
        data[0]?.["ItemResource.IMGSpinSet.resourceAltText_ss"]
      threeSixtyResourceDataState.resourceFullWebUrl =
        data[0]?.["ItemResource.IMGSpinSet.resourceFullWebURL_ss"]
      threeSixtyResourceDataState.resourceName =
        data[0]?.["ItemResource.IMGSpinSet.resourceName_ss"]
      threeSixtyResourceDataState.resourceTypeImg =
        data[0]?.["ItemResource.IMGSpinSet.resourceType_ss"]
    }
  }

  const isBundleProduct = Boolean(primaryBundleSKUs)

  const productName = isParts ? productNameInit : pdpBrnadName
  const [name, setName] = useState(productName)

  const staticTexts = usePdpi18n(authorData, badgeText, name)

  const findStoreUrl = getShortenedUrlwithGeneral(findStorePagePath, general)
  const findProPagePath = getShortenedUrlwithGeneral(
    findProPagePathUrl,
    general
  )

  const getProductDetails = reqData => {
    const { slug, selectedSku = "" } = reqData

    try {
      const payload = {
        slug,
        isParts,
        brandName,
        selectedSku: selectedSku,
        selectedColor,
        lwAppName,
        setSkuVariantCb: initSku => setSkuVariant(initSku),
      }
      // Get product data from LucidWorks
      dispatch(searchPdp(payload))
        .unwrap()
        .then(res => {
          if (res) {
            if (
              typeof window !== "undefined" &&
              window.kohler?.datalayer?.readyState === "ready"
            ) {
              const kohlerDatalayer = window.kohler.datalayer
              if (kohlerDatalayer?.setItem) {
                kohlerDatalayer.setItem("PDP_LW_DATA", res)
              }
              kohlerDatalayer.publish(kohlerDatalayer.EventTypes.SHOW, {
                type: "page",
              })
            }
            const {
              productData = {},
              fusionQueryId = "",
              customerFacingSKU = "",
              dimensionData = {},
              threeSixtyResourceDataState = {},
              slug = "",
              fusion = {},
              docs,
            } = res
            const { masterSKU_s: masterSku = "" } = productData

            const {
              facet_labels: facetLabels = [],
              Color_data: colorData = {},
              options: {
                response: { docs: variantOptions = [] } = {},
                facet_counts: { facet_fields: facets } = {},
              } = {},
              masterVariantDataResponse = [],
            } = fusion

            dispatch(setRequiredItemsSkuData({ data: docs }))
            const variantData = masterVariantDataResponse.map(e => e.sku_s)

            const excludedStates = _get(
              masterVariantDataResponse.find(
                item => item.sku_s === selectedSku
              ),
              "RegionStatesExcluded_ss",
              []
            )
            setExcludedStates(excludedStates)

            const currOptions =
              variantOptions.find(e => {
                const variantList = e["variantList.sku_ss"]
                return variantList.includes(selectedSku)
              }) ?? {}

            const colorDetails = getColorFinishData(colorData)
            setColorSKUDetailss(colorDetails)
            setProductServices(_get(productData, "ProductServices_ss", ""))

            // get product options
            if (
              productData["ProductIsRetail"] !== "true" &&
              productData["Product_Category"]
            ) {
              setSuperSku(productData["Super_Sku"])
            }

            setPdpData(productData)

            setState(prevState => {
              return {
                ...prevState,
                productDetailData: productData,
                customerFacingSKU,
                masterSku,
                fusionQueryId,
                viewLoader: false,
                dimensionData,
                threeSixtyResourceDataState,
                slug,
                options: facets,
                currOptions,
                facetLabels,
                variantOptions,
                variantData,
              }
            })

            window.addEventListener("popstate", () => {
              fetchSkuFromUrl()
            })

            setState(prevState => {
              return {
                ...prevState,
                viewLoader: false,
              }
            })
          } else {
            console.error("Error occured while fetching product data")
          }
        })

      // Get product data from CommerceTools
    } catch (error) {
      console.error(error)
    }

    if (authorData) {
      const {
        promoConfigDesc = "",
        enablePromo = "",
        installServices = [],
        designServices = [],
        findAnInstaller,
        installerArea,
        mboxIdList = [],
        jsonFilePath = "",
      } = authorData

      setState(prevState => {
        return {
          ...prevState,
          promoDescription: promoConfigDesc,
          enablePromo,
          installationDataFromProp: installServices,
          designServiceDataFromProp: designServices,
          jsonFileUrl: jsonFilePath,
          findInstallerPath: findAnInstaller,
          installerArea,
          mboxes: mboxIdList,
        }
      })
    }
    // Get product data from CommerceTools
    dispatch(getProductBySlug({ slug }))
      .unwrap()
      .then(product => {
        if (product.id)
          setState(prevState => {
            return { ...prevState, ctData: product }
          })
      })
  }

  const updateImageClickCounter = () => {
    setState(prevState => {
      return {
        ...prevState,
        imageClickCounter: imageClickCounter + 1,
      }
    })
  }

  const setSkuVariant = sku => {
    sku &&
      setState(prevState => {
        return {
          ...prevState,
          selectedSku: sku,
          isProductVariantClicked: true,
          clickedProductVariant: false,
        }
      })
    const url = new URL(window?.location?.href)
    const searchParams = url?.searchParams
    const skuNumber = searchParams?.get("skuNumber")
    skuNumber
      ? searchParams?.set("skuNumber", sku)
      : searchParams?.set("skuId", sku)
    const query = "?" + searchParams?.toString()

    window?.history?.replaceState(
      window?.location?.pathname,
      document.title,
      query
    )
    dispatch(setPDP({ sku }))
  }

  const handleOnSelectedColorSku = sku => {
    setSkuVariant(sku)
    const currOptions =
      variantOptions.find(e => {
        const variantList = e["variantList.sku_ss"]
        return variantList.includes(sku)
      }) ?? {}

    const { slug_s: currentSlug = "" } = currOptions
    const slugName = currentSlug || slug

    const requestData = {
      slug: slugName,
      selectedSku: sku,
    }

    if (slugName) {
      getProductDetails(requestData)
      if (currentSlug) {
        const pdpUrl = getPdpUrlPath(category, slugName)
        const param = sku ? `skuId=${sku}` : ""
        const redirectUrl = getPdpRedirectUrl(pdpUrl, param)
        setSlug(slugName)
        router.push(redirectUrl, null, { shallow: true })
      }
    }
  }

  const addRequiredItems = list => {
    setState(prevState => {
      return {
        ...prevState,
        reqCartData: list,
      }
    })
  }

  const addToCart = (items, cb = () => {}) => {
    let totalAdded = 0
    items.forEach(item => (totalAdded += item.quantity))
    const callbackFun = (data = {}) => {
      const { res: { lineItems = [] } = {} } = data
      if (lineItems.length > 0) {
        if (!_isEmpty(authorData)) {
          try {
            const { hapticFeedbackTimer = 0 } = authorData
            window?.navigator?.vibrate(Number(hapticFeedbackTimer))
          } catch (err) {
            cb()
          }
        }
      }
      cb()
    }

    addToCartHelper([...items, ...state.reqCartData], "", obj => {
      dispatch(showPreviewCart())
      callbackFun(obj)
    })
  }

  const fetchSkuFromUrl = () => {
    setState(prevState => {
      return {
        ...prevState,
        selectedSku: skuId || state.selectedSku,
      }
    })
  }

  // Search for product variant based on selected option and redirect to that PDP
  const selectOption = async selectedData => {
    const { slug, sku } = selectedData || {}

    setState(prevState => {
      return {
        ...prevState,
        selectedSku: sku,
        isOptionClicked: true,
      }
    })
    const requestData = {
      slug,
      selectedSku: sku,
    }
    getProductDetails(requestData)
    if (slug) {
      const pdpUrl = await getPDPUrl(category, slug)
      const param = sku ? `skuId=${sku}` : ""
      const redirectUrl = getPdpRedirectUrl(pdpUrl, param)
      setSlug(slug)

      router.push(redirectUrl, null, { shallow: true })
    }
  }

  const seeAvailableColor = () => {
    setSkuVariant(availableColorFirstSku)
    dispatch(getDiscontinuedProductValue(""))
  }

  const getZipCode = (userZipCode, handleZipCodeAvailabilityCallBack) => {
    checkUserZipCode({
      userZipCode,
      state,
      callBack: handleZipCodeAvailabilityCallBack,
      productServices,
    })
  }

  const getAvailableStock = async sku => {
    let stock
    try {
      stock = await getStock(sku)
      if (isOptionClicked) {
        setIsInventoryUpdates(true)
      }
    } catch (err) {
      console.error(
        "Error | getStock | getAvailablesStock | ProductDetails | ",
        err
      )
    }
    setState(prevState => {
      return {
        ...prevState,
        availableStock: stock ?? 0,
        loadShowEvent: true,
        clickedProductVariant: state.isProductVariantClicked,
      }
    })
  }

  useEffect(() => {
    if (state?.isOptionClicked) {
      setState(prevState => {
        return {
          ...prevState,
          isOptionClicked: false,
        }
      })
      setTimeout(() => {
        setIsSkuOptionClicked(true)
        setIsInventoryUpdates(false)
      }, 500)
    }
  }, [isInventoryUpdates])

  const getServiceData = async () => {
    let designServiceSkus = []
    let installationServiceSkus = []
    if (!_isEmpty(designServiceDataFromProp)) {
      designServiceSkus = designServiceDataFromProp.map(product => {
        if (product.sku) {
          return product.sku
        }
      })
    }
    if (!_isEmpty(installationDataFromProp)) {
      installationServiceSkus = installationDataFromProp.map(list => {
        if (list.sku) {
          return list.sku
        }
      })
    }

    if (designServiceSkus.length === 0 && installationServiceSkus.length === 0)
      return

    const payload = {
      slug,
      skus: [
        ...designServiceSkus,
        ...installationServiceSkus,
        ...(isBundleProduct ? [...bundleSKUList, selectedSku] : []),
      ],
    }

    dispatch(getProductBySlugAndSku(payload))
      .unwrap()
      .then((products = []) => {
        const installationServices = products.filter(product =>
          installationServiceSkus.includes(product?.masterVariant?.sku)
        )
        const designServices = products.filter(product =>
          designServiceSkus.includes(product?.masterVariant?.sku)
        )

        const ctData =
          products.filter(
            product =>
              !installationServiceSkus.includes(product?.masterVariant?.sku) &&
              !designServiceSkus.includes(product?.masterVariant?.sku)
          ) ?? []

        const masterVarientSkuId = isBundleProduct
          ? ctData?.masterVariant?.sku ?? ""
          : ctData?.[0]?.masterVariant?.sku ?? ""
        const url = new URL(window?.location?.href)
        const skuId = url?.searchParams?.get("skuId") ?? masterVarientSkuId

        const currentSkuData =
          ctData.find(e => {
            const findData = e.variants.find(el => {
              return el.sku === skuId
            })
            if (findData || e.masterVariant.sku === skuId) return e
          }) ?? {}

        setState(prevState => {
          return {
            ...prevState,
            designServiceData: designServices,
            installationData: installationServices,
            ctData: currentSkuData,
            projectionData: products,
          }
        })

        if (installationServices.length > 0) {
          getUserLocation()
        }
      })
  }

  const getUserLocation = () => {
    getLocationByCookies().then(getLocation => {
      const userZipCode = getLocation.zipcode ?? ""
      checkUserZipCode({ userZipCode, state })
    })
  }

  const removeVariantSelection = () => {
    setState(prevState => {
      return {
        ...prevState,
        clickedProductVariant: false,
        isProductVariantClicked: false,
      }
    })
  }

  useEffect(() => {
    setState(blankState)
  }, [])

  useEffect(() => {
    let pdpPropsLoadedTimer
    if (!_isEmpty(pdprops)) {
      pdpPropsLoadedTimer = setTimeout(() => {
        setIsPdpPropsLoaded(true)
      }, 1000)
    }

    return () => {
      if (pdpPropsLoadedTimer) {
        clearTimeout(pdpPropsLoadedTimer)
      }
    }
  }, [pdprops])

  useEffect(() => {
    if (analyticsData && window.kohler?.datalayer?.setItem) {
      window.kohler.datalayer.setItem("PAGE_INFO", analyticsData)
    }
  }, [analyticsData])

  useEffect(() => {
    getServiceData()
    setSuperSku("")
    setAvailableColorFirstSku("")
    setProductServices("")
    setComboSku([])
    setRegionSoldOnline([])
    setImagesData([])
    setVideoIds([])
    setPricesData([])
    setListPrices([])
    setDiscountedPrices([])
    setDiscountPercent([])
    setIsType([])
    setBadgesProps([])
    setExcludedStates([])
    setPartReplacementSuggestions([])
  }, [slug])

  useEffect(() => {
    if (designServiceDataFromProp.length || installationDataFromProp.length)
      getServiceData()
  }, [designServiceDataFromProp, installationDataFromProp])

  useEffect(() => {
    if (primaryBundleSKUs) getServiceData()
  }, [primaryBundleSKUs])

  useEffect(() => {
    if (accessToken) {
      const persona = getUserPersona()
      setState(prevState => {
        return { ...prevState, persona }
      })
    }
  }, [accessToken, slug])

  useEffect(() => {
    if (disableEcommerce) {
      setState(prevState => {
        return { ...prevState, persona: "" }
      })
    }
  }, [disableEcommerce])

  useEffect(() => {
    if (!stateListPath) {
      dispatch(getGenericListPath())
    } else {
      dispatch(getstateList())
        .unwrap()
        .then(res =>
          setState(prevState => {
            return { ...prevState, statesData: res }
          })
        )
    }
  }, [stateListPath])

  useEffect(() => {
    if (typeof window !== "undefined") {
      const url = new URL(window.location.href)
      if (skuId && !url.searchParams.get("skuNumber")) {
        setState(prevState => {
          return {
            ...prevState,
            selectedSku: skuId,
          }
        })
      }
    }
  }, [skuId])

  useEffect(() => {
    setState(prevState => {
      return {
        ...prevState,
        reverseGeo: reverseGeo,
      }
    })
  }, [reverseGeo])

  useEffect(() => {
    if (!_isEmpty(authorData) && !_isEmpty(general)) {
      setReplaceAddToCartCtaLink(
        getShortenedUrlwithGeneral(authorData?.replaceAddToCartCtaLink, general)
      )
      const { presetConfigs = "{}" } = authorData ?? { presetConfigs: "{}" }
      const presetConfigObject = JSON.parse(presetConfigs)
      setPresetConfigObject(presetConfigObject)
    }
  }, [authorData, general])

  useEffect(() => {
    if (slug && accessToken) {
      const requestData = {
        slug,
        selectedSku,
      }
      getProductDetails(requestData)
    }
  }, [accessToken])

  useEffect(() => {
    if (jsonFileUrl) {
      getZipCodeJsonFile(jsonFileUrl, data => {
        const { zipcode = [] } = data
        setState(prevState => {
          return {
            ...prevState,
            zipCodeData: zipcode,
          }
        })
      })
    }
  }, [jsonFileUrl])

  useEffect(() => {
    const name = isParts ? productNames : regionBrandNames
    setName(name)
  }, [productNames, regionBrandNames])

  useEffect(() => {
    if (!_isEmpty(productDetailData)) {
      let imagesData = []
      let videoIds = []
      const pricesData = []
      const listPrices = []
      let colorsData = []
      let variants = []
      let colors = []
      const comboSku = []
      const discountedPrices = []
      const discountPercent = []
      let requiredItemstoInstall = []
      const availableColors = []
      const disContinuedColors = []
      const customerSkus = []
      const isType = []
      const regionSoldOnline = []
      const partReplacementSuggestions = []
      let isRegionSoldOnline = false
      // get list of variants
      if (productDetailData["variantList.sku_ss"]) {
        variants = productDetailData["variantList.sku_ss"]
      }
      // get list of variant colors
      const colorDetailsss =
        colorSKUDetailss || (productDetailData["Color.SKU.Details_ss"] ?? [])

      if (colorDetailsss) {
        colors = colorDetailsss.map(color => {
          const d = color.split("|")
          return getColorDataObject(d)
        })
      }

      // get required items to install
      const accessoryGroups =
        productDetailData["ProductRequiredAccessoryGroup_s"]
      const accessoryGroupss =
        productDetailData["ProductRequiredAccessoryGroup_ss"]

      if (!disableEcommerce || isCanadaSite(brandName)) {
        if (accessoryGroups) {
          requiredItemstoInstall = [accessoryGroups]
        } else if (accessoryGroupss) {
          requiredItemstoInstall = accessoryGroupss
        }
      }
      // get Youtube Url's
      const productYoutubeIDs = productDetailData["ProductYoutubeID_s"]
      if (productYoutubeIDs) {
        videoIds = productYoutubeIDs
          .split("|")
          .map(v => ({ type: "video", url: v }))
        setVideoIds(videoIds)
      }
      if (cart.lineItems && cart.lineItems.length) {
        cart.lineItems
          .filter(item => item.productSlug["en-US"] === slug)
          .map(product => {
            if (product.price?.discounted) {
              discountedPrices[product.variant.sku] = Number(
                (product.price.discounted.value.centAmount / 100).toFixed(2)
              )
              setDiscountedPrices(discountedPrices)
              let percentOff
              if (
                product.price?.discounted.discount.obj.value?.type ===
                "absolute"
              ) {
                percentOff = _get(
                  product.price,
                  "discounted.discount.obj.value.money[0].centAmount",
                  0
                )
                isType[product.variant.sku] = "absolute"
                setIsType(isType)
              } else {
                percentOff = _get(
                  product.price,
                  "discounted.discount.obj.value.permyriad",
                  0
                )
                isType[product.variant.sku] = "relative"
                setIsType(isType)
              }
              discountPercent[product.variant.sku] =
                percentOff > 0 ? Number(percentOff / 100) : 0
              setDiscountPercent(discountPercent)
            }
          })
      }
      // get data related to each color variant
      colors.forEach(color => {
        const colorObj = {
          id: color.sku,
          name: "product-color",
          value: color.sku,
          label: color.name,
          notApplicable: color.swatch.toLowerCase() === SWATCH_NA.toLowerCase(),
          colorUrl: CONSTANTS.COLOR_FILE_URL + color.swatch,
          checked: color.sku === state.selectedSku,
          discontinuedColor: color.discontinued,
        }
        color.discontinued
          ? disContinuedColors.push(colorObj)
          : availableColors.push(colorObj)
        customerSkus[color.sku] = color.customerSku
      })
      const isDisContinuedColor = colors.find(
        color => color.sku === state.selectedSku
      )?.discontinued
      colorsData = isDisContinuedColor ? disContinuedColors : availableColors

      if (availableColors && availableColors[0])
        setAvailableColorFirstSku(availableColors[0].id ?? "")
      const variantImages = productDetailData["productImages.labelWithUrl_ss"]
        ? productDetailData["productImages.labelWithUrl_ss"]
        : []

      let variantImageLabels = []
      let variantImageURLs = []
      if (variantImages?.length) {
        const selVarImageUrls = []
        const selVarImageLabels = []
        variantImages.map(img => {
          const imgDetail = img.split("|")
          if (state.selectedSku === imgDetail[0]) {
            selVarImageLabels.push(imgDetail[4] ?? "")
            selVarImageUrls.push(
              imgDetail[imgDetail.length - 1]
                ? imgDetail[imgDetail.length - 1]
                : MissingImage?.src
            )
          } else if (!variants.find(v => v === imgDetail[0])) {
            variantImageLabels.push(imgDetail[4] ?? "")
            variantImageURLs.push(
              imgDetail[imgDetail.length - 1]
                ? imgDetail[imgDetail.length - 1]
                : MissingImage?.src
            )
          }
        })
        variantImageLabels = [...selVarImageLabels, ...variantImageLabels]
        variantImageURLs = [...selVarImageUrls, ...variantImageURLs]
        if (variantImageURLs.length < 1) {
          variantImageLabels.push(state.selectedSku)
          variantImageURLs.push(MissingImage?.src)
        }
      } else {
        variantImageLabels.push(state.selectedSku)
        variantImageURLs.push(MissingImage?.src)
      }

      imagesData = getFormatedImages({
        variantImageLabels,
        variantImageURLs,
        authorData,
      })

      setImagesData(imagesData)
      for (let i = 0; i < variants.length; i++) {
        const variantSku = variants[i]
        if (state.ctData?.masterVariant) {
          let product = {}
          if (variantSku === state.ctData.masterVariant.sku) {
            product = state.ctData.masterVariant
          } else {
            product = state.ctData.variants.find(
              variant => variantSku === variant.sku
            )
          }

          // Get variant prices from CT data
          const fixedPromo = product?.prices?.find(
            price =>
              price.value?.currencyCode === currencyCode &&
              price.customerGroup?.obj?.key === persona &&
              price.custom?.fields?.fixedPrice
          )

          const productPrice = product?.prices?.find(
            price =>
              price.value?.currencyCode === currencyCode &&
              price.customerGroup?.obj?.key === persona
          )

          let priceObj = fixedPromo ? fixedPromo : productPrice

          if (!priceObj?.value) {
            priceObj = product?.prices?.find(
              price =>
                price.value?.currencyCode === currencyCode &&
                !price.customerGroup
            )
          }

          pricesData[variantSku] = Number(
            ((priceObj?.value?.centAmount ?? 0) / 100).toFixed(2)
          )
          setPricesData(pricesData)

          if (
            discountedPrices[variantSku] === 0 ||
            !discountedPrices[variantSku]
          ) {
            discountedPrices[variantSku] = Number(
              ((priceObj?.discounted?.value?.centAmount ?? 0) / 100).toFixed(2)
            )
            setDiscountedPrices(discountedPrices)
            if (
              priceObj?.discounted?.discount?.obj?.value.type === "absolute"
            ) {
              discountPercent[variantSku] = Number(
                (priceObj?.discounted?.discount?.obj?.value?.money[0]
                  ?.centAmount ?? 0) / 100
              )
              setDiscountPercent(discountPercent)
              isType[variantSku] = "absolute"
              setIsType(isType)
            } else {
              discountPercent[variantSku] = Number(
                (priceObj?.discounted?.discount?.obj?.value?.permyriad ?? 0) /
                  100
              )
              setDiscountPercent(discountPercent)
              isType[variantSku] = "relative"
              setIsType(isType)
            }
          }

          // price-checking done for product(price & discounted price)
          setIsPriceChecked(true)

          const listPrice = product?.prices?.find(
            price =>
              price.value?.currencyCode === currencyCode && !price.customerGroup
          )
          listPrices[variantSku] = Number(
            ((listPrice?.value?.centAmount ?? 0) / 100).toFixed(2)
          )
          setListPrices(listPrices)
          // Check if variant is a Combo SKU
          comboSku[variantSku] = product?.attributes.find(
            attr => attr.name === "ComboSKU"
          )
            ? true
            : false
          setComboSku(comboSku)
          // Check if RegionSoldOnline
          const isOnline = _get(
            product?.attributes.find(attr => attr.name === "RegionSoldOnline"),
            "value",
            ""
          )
          regionSoldOnline[variantSku] = isOnline
          isRegionSoldOnline = !isOnline
          setRegionSoldOnline(regionSoldOnline)
          // Check if Service Part have replacement suggestion
          if (authorData.ctRecommendations) {
            if (0 in authorData.ctRecommendations) {
              partReplacementSuggestions[variantSku] = _get(
                product?.attributes.find(
                  attr =>
                    attr.name === authorData.ctRecommendations[0].fieldname
                ),
                "value",
                ""
              )
              setPartReplacementSuggestions(partReplacementSuggestions)
            }
          }
        }
      }
      const selectedColor = _get(
        colorsData.find(item => item.id === state.selectedSku),
        "label",
        ""
      )
      if (!loadShowEvent) return
      const pdpPayload = {
        state,
        customerSkus,
        selectedColor,
        isParts,
        currencySign,
        requiredItemstoInstall,
        colorsData,
        comparedProducts,
        disableEcommerce,
        favorites,
        superSku,
        cartLoaded,
        cart,
        pricesData,
        locale,
        discountedPrices,
      }
      const pdprops = getPdpProps(pdpPayload)
      if (
        pdprops.ProductPriceSpiderIncluded_s ||
        isDisContinuedColor ||
        isRegionSoldOnline
      ) {
        if (pdprops.ProductPriceSpiderIncluded_s) {
          pdprops.productPartnerBuyNow = true
        }
        if (!skuId.startsWith("BNDL") && !isBundleProduct) {
          pdprops.productSaleable = false
        }
      }

      setPdprops(pdprops)

      // Get badge values for product
      const shipmentDate = _get(
        state.productDetailData,
        "RegionReleaseforShipment_dt",
        ""
      )
      const exclusiveBadge = parseToBoolean(
        _get(state.productDetailData, "ProductIsExclusive_s", "")
      )
      const badgesProps = {
        isNewProduct: showNewBadge(shipmentDate),
        badgeVal: _get(
          state.productDetailData,
          `priceList.${persona}.saleOffer_s`,
          ""
        ),
        exclusiveBadge,
      }
      setBadgesProps(badgesProps)
      const { presetConfigs = "{}" } = authorData ?? { presetConfigs: "{}" }
      const presetConfigObject = JSON.parse(presetConfigs)
      setPresetConfigObject(presetConfigObject)
    }
  }, [
    productDetailData,
    selectedSku,
    persona,
    variantData,
    ctData,
    loadShowEvent,
    clickedProductVariant,
    availableStock,
    favorites,
    colorSKUDetailss,
  ])

  const { selectedColor = "" } = pdprops

  const allVariants = ctData?.variants?.concat(ctData.masterVariant)
  const { attributes: currentSkuAttributes = [] } =
    allVariants?.find(variant => variant.sku === state.selectedSku) || {}

  const { value: isBackorderable = false } =
    currentSkuAttributes?.find(attr => attr.name === "RegionIsBackorderable") ||
    {}

  const { value: leadTime = 0 } =
    currentSkuAttributes?.find(attr => attr.name === "RegionLeadTime") || {}

  const addToCartProps = {
    ...pdprops.addToCartProps,
    backOrder: isBackorderable ? "Yes" : "No",
    leadTime,
    availableStock,
    isBackorderable,
  }

  useEffect(() => {
    if (typeof window !== "undefined" && typeof document !== "undefined") {
      const hashedId = window?.location?.href?.split("#")?.[1] ?? ""
      const timeout = setTimeout(() => {
        const element = document.getElementById(hashedId)
        if (hashedId && element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "end",
            inline: "nearest",
          })
        }
      }, 5000)

      return () => {
        clearTimeout(timeout)
      }
    }
  }, [])

  useEffect(() => {
    setSlug(slugProp)
  }, [slugProp])

  useEffect(() => {
    if (selectedSku) {
      getAvailableStock(selectedSku)
      dispatch(setPDP({ sku: selectedSku }))
    }
  }, [selectedSku])

  useEffect(() => {
    if (brandName) {
      const payload = { brandName }
      dispatch(getPdpTooltip(payload))
        .unwrap()
        .then(res => {
          const tooltipData = res ?? {}
          setState(prevState => {
            return { ...prevState, selectMoreTooltipData: tooltipData }
          })
        })
    }
  }, [brandName])

  if (
    !_isEmpty(state.productDetailData) &&
    !state.viewLoader &&
    (pdprops.name || pdprops.desc)
  ) {
    return (
      <ProductDetailView
        {...pdprops}
        {...state}
        addToCartProps={addToCartProps}
        customerFacingSKU={pdprops.customerFacingSKU}
        curroptions={state.currOptions}
        imagesData={[...imagesData, ...videoIds]}
        isPdpPropsLoaded={isPdpPropsLoaded}
        staticTexts={staticTexts}
        productCategory={category}
        productLCategory={localCategory}
        productServices={productServices}
        isComboSku={comboSku[selectedSku]}
        isRegionSoldOnline={
          disableEcommerce ? false : regionSoldOnline[selectedSku]
        }
        price={pricesData[selectedSku]}
        listPrice={listPrices[selectedSku]}
        discountedPrice={discountedPrices[selectedSku] ?? 0}
        discountPercent={discountPercent[selectedSku] ?? 0}
        isType={isType[selectedSku]}
        setSkuVariant={handleOnSelectedColorSku}
        selectoption={selectOption}
        getStock={() => getStock(selectedSku)}
        onAddToCart={addToCart}
        setIsLoadTargetRequired={setIsLoadTargetRequired}
        isLoadTargetRequired={isLoadTargetRequired}
        onAddToCompare={() =>
          addToCompareProduct(
            selectedSku,
            productDetailData,
            addToCartProps?.isBackorderable,
            slug
          )
        }
        onRemoveFromCompare={() => removeFromCompareProduct(selectedSku)}
        checkProductCategory={() =>
          checkProductCategory(productCategory, category)
        }
        comparedProductsCount={comparedProducts.length}
        isParts={isParts}
        findProPagePath={findProPagePath}
        addItemsToCart={addRequiredItems}
        showToaster={showToaster}
        onAvailableColor={seeAvailableColor}
        cart={cart}
        getZipCode={getZipCode}
        findStoreUrl={findStoreUrl}
        badgesProps={badgesProps}
        findInstallerPath={getShortenedUrlwithGeneral(
          findInstallerPath,
          general
        )}
        removeVariantSelection={removeVariantSelection}
        excludedState={getShippingLocations(statesData, excludedStates)}
        pdpJson={authorData}
        presetConfigObject={presetConfigObject}
        setProductInfo={data => dispatch(setProductInfo(data))}
        partReplacementSuggestions={partReplacementSuggestions[selectedSku]}
        updateImageClickCounter={updateImageClickCounter}
        productData={productDetailData}
        replaceAddToCart={Boolean(authorData.replaceAddToCart)}
        disableRatings={Boolean(authorData.disableRatings)}
        replaceAddToCartCtaLink={replaceAddToCartCtaLink ?? findStoreUrl}
        linkNewTab={Boolean(authorData.linkNewTab)}
        replaceAddToCartCtaLabel={
          authorData.replaceAddToCartCtaLabel ?? t("kf.global.label.findStore")
        }
        docId={id}
        config={globalConfig}
        initialImgAlt={initialImgAlt}
        initialImgUrl={initialImgUrl}
        waterSenseProduct={pdpData["ProductWaterSense_ss"] || []}
        isInstock={pdpData["productIsInStock_b"] || false}
        brandName={brandName}
        isPriceChecked={isPriceChecked}
        dimensionData={dimensionData}
        threeSixtyResourceData={threeSixtyResourceDataState}
        savedListLineItems={saveToListLineItems}
        isSkuOptionClicked={isSkuOptionClicked}
        setIsSkuOptionClicked={setIsSkuOptionClicked}
        regionBrandNames={regionBrandNames}
        isIscUser={isIscUser}
      />
    )
  }
  return (
    <PDPLoader
      pdpJson={authorData}
      pdpData={pdpData}
      skuId={skuId}
      initialImgAlt={initialImgAlt}
      initialImgUrl={initialImgUrl}
    />
  )
}

export default ProductDetail
